import React, { useState } from 'react';
import { MicIcon, CheckCircle2Icon, SparklesIcon, SlidersIcon } from 'lucide-react';
export function BrandVoiceCalibrator() {
  const [step, setStep] = useState(1);
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const handleNext = () => {
    if (step < 3) {
      setStep(step + 1);
    } else {
      setIsGenerating(true);
      setTimeout(() => {
        setIsGenerating(false);
        setHasGenerated(true);
      }, 2000);
    }
  };
  return <div className="max-w-4xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-161">
      <div data-id="element-162">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-163">
          Calibrador de Voz de Marca
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-164">
          Define la personalidad de tu marca para que la IA escriba exactamente
          como tú.
        </p>
      </div>

      {!hasGenerated ? <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-200" data-id="element-165">
          <div className="flex items-center justify-between mb-8" data-id="element-166">
            <div className="flex gap-2" data-id="element-167">
              {[1, 2, 3].map(i => <div key={i} className={`h-2 w-16 rounded-full ${i <= step ? 'bg-indigo-600' : 'bg-slate-200'}`} data-id="element-168" />)}
            </div>
            <span className="text-sm font-medium text-slate-500" data-id="element-169">
              Paso {step} de 3
            </span>
          </div>

          {step === 1 && <div className="space-y-6 animate-in slide-in-from-right-4" data-id="element-170">
              <h2 className="text-xl font-bold text-slate-900" data-id="element-171">
                ¿Cómo te diriges a tu audiencia?
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-172">
                <label className="border-2 border-indigo-600 bg-indigo-50 p-4 rounded-xl cursor-pointer relative" data-id="element-173">
                  <input type="radio" name="q1" className="sr-only" defaultChecked data-id="element-174" />
                  <div className="absolute top-4 right-4 text-indigo-600" data-id="element-175">
                    <CheckCircle2Icon className="w-5 h-5" data-id="element-176" />
                  </div>
                  <span className="font-bold text-indigo-900 block mb-1" data-id="element-177">
                    Cercano y Amigable (Tú)
                  </span>
                  <span className="text-sm text-indigo-700" data-id="element-178">
                    "Hola hermosa, hoy te enseño..."
                  </span>
                </label>
                <label className="border-2 border-slate-200 hover:border-slate-300 p-4 rounded-xl cursor-pointer" data-id="element-179">
                  <input type="radio" name="q1" className="sr-only" data-id="element-180" />
                  <span className="font-bold text-slate-900 block mb-1" data-id="element-181">
                    Profesional y Formal (Usted)
                  </span>
                  <span className="text-sm text-slate-500" data-id="element-182">
                    "Bienvenidos, en esta clase aprenderemos..."
                  </span>
                </label>
              </div>
            </div>}

          {step === 2 && <div className="space-y-6 animate-in slide-in-from-right-4" data-id="element-183">
              <h2 className="text-xl font-bold text-slate-900" data-id="element-184">
                ¿Qué tanto usas emojis?
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-185">
                <label className="border-2 border-slate-200 hover:border-slate-300 p-4 rounded-xl cursor-pointer text-center" data-id="element-186">
                  <input type="radio" name="q2" className="sr-only" data-id="element-187" />
                  <span className="text-3xl block mb-2" data-id="element-188">📄</span>
                  <span className="font-bold text-slate-900 text-sm" data-id="element-189">
                    Casi nada
                  </span>
                </label>
                <label className="border-2 border-indigo-600 bg-indigo-50 p-4 rounded-xl cursor-pointer text-center relative" data-id="element-190">
                  <input type="radio" name="q2" className="sr-only" defaultChecked data-id="element-191" />
                  <div className="absolute top-2 right-2 text-indigo-600" data-id="element-192">
                    <CheckCircle2Icon className="w-4 h-4" data-id="element-193" />
                  </div>
                  <span className="text-3xl block mb-2" data-id="element-194">✨🍰</span>
                  <span className="font-bold text-indigo-900 text-sm" data-id="element-195">
                    Moderado (Para resaltar)
                  </span>
                </label>
                <label className="border-2 border-slate-200 hover:border-slate-300 p-4 rounded-xl cursor-pointer text-center" data-id="element-196">
                  <input type="radio" name="q2" className="sr-only" data-id="element-197" />
                  <span className="text-3xl block mb-2" data-id="element-198">🚀🔥😱👇</span>
                  <span className="font-bold text-slate-900 text-sm" data-id="element-199">
                    Muchos (Muy expresivo)
                  </span>
                </label>
              </div>
            </div>}

          {step === 3 && <div className="space-y-6 animate-in slide-in-from-right-4" data-id="element-200">
              <h2 className="text-xl font-bold text-slate-900" data-id="element-201">
                Pega un texto tuyo (Opcional)
              </h2>
              <p className="text-sm text-slate-500" data-id="element-202">
                Para que la IA analice tu ritmo y vocabulario exacto.
              </p>
              <textarea className="w-full h-32 p-4 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Pega aquí un post de Instagram o un correo que hayas escrito tú misma..." defaultValue="¡Hola chicas! Hoy les quiero contar cómo logré que este pastel de chocolate me quedara súper húmedo. La verdad es que antes se me secaba muchísimo y me daba una rabia tremenda 🤦‍♀️ Pero descubrí un truquito súper fácil..." data-id="element-203" />
            </div>}

          <div className="mt-8 flex justify-end pt-6 border-t border-slate-100" data-id="element-204">
            <button onClick={handleNext} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-2.5 rounded-lg font-medium flex items-center gap-2 transition-colors" data-id="element-205">
              {isGenerating ? <>
                  <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-206" /> Analizando
                  Voz...
                </> : step < 3 ? 'Siguiente Paso' : <>
                  <SparklesIcon className="w-5 h-5" data-id="element-207" /> Calibrar Voz de Marca
                </>}
            </button>
          </div>
        </div> : <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-208">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-200" data-id="element-209">
            <div className="flex items-center gap-3 mb-6" data-id="element-210">
              <div className="p-3 bg-indigo-100 text-indigo-600 rounded-xl" data-id="element-211">
                <MicIcon className="w-6 h-6" data-id="element-212" />
              </div>
              <div data-id="element-213">
                <h2 className="text-xl font-bold text-slate-900" data-id="element-214">
                  Perfil de Voz Guardado
                </h2>
                <p className="text-sm text-slate-500" data-id="element-215">
                  Este perfil se aplicará automáticamente a todos tus futuros
                  copies.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-216">
              <div data-id="element-217">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-218">
                  Tono General
                </span>
                <p className="font-medium text-slate-900 mt-1" data-id="element-219">
                  Cercano, Empático, "Amiga a Amiga"
                </p>
              </div>
              <div data-id="element-220">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-221">
                  Vocabulario
                </span>
                <p className="font-medium text-slate-900 mt-1" data-id="element-222">
                  Sencillo, emocional, usa diminutivos ("truquito")
                </p>
              </div>
              <div data-id="element-223">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-224">
                  Ritmo de Frases
                </span>
                <p className="font-medium text-slate-900 mt-1" data-id="element-225">
                  Frases cortas, conversacionales, pausas dramáticas.
                </p>
              </div>
              <div data-id="element-226">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-227">
                  Uso de Emojis
                </span>
                <p className="font-medium text-slate-900 mt-1" data-id="element-228">
                  Moderado. Preferencia por: ✨ 🤦‍♀️ 🍰 👇
                </p>
              </div>
            </div>

            <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-6" data-id="element-229">
              <div className="flex items-center gap-2" data-id="element-230">
                <div className="w-10 h-6 bg-indigo-600 rounded-full relative cursor-pointer" data-id="element-231">
                  <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" data-id="element-232"></div>
                </div>
                <span className="text-sm font-medium text-slate-700" data-id="element-233">
                  Aplicar a todos los outputs por defecto
                </span>
              </div>
              <button className="text-indigo-600 hover:text-indigo-800 font-medium text-sm flex items-center gap-1" data-id="element-234">
                <SlidersIcon className="w-4 h-4" data-id="element-235" /> Recalibrar
              </button>
            </div>
          </div>
        </div>}
    </div>;
}